
import { computed, defineComponent } from 'vue';
import { setBg, formatSecond } from '@utiles/index';
import ArticleCountDown from '@components/article/ArticleCountDown.vue';
import useArticleJumpLink from '@hooks/useArticleJumpLink';
import { useStore } from 'vuex';
export default defineComponent({
  name: 'ArticleItem',
  props: {
    leftLink: {
      required: true,
      default: '',
    },
    rightLink: {
      required: true,
      default: '',
    },
    itemBg: {
      required: false,
      default: '',
    },
    leftBg: {
      required: true,
      default: '',
    },
    articleTitle: {
      required: true,
      default: '',
    },
    articleDesc: {
      required: true,
      default: '',
    },
    articleId: {
      required: true,
      default: '',
    },
    tag: {
      required: false,
      default: '',
    },
    countdownSecond: {
      required: false,
      default: 0,
    },
    redirectLink: {
      required: false,
      default: '',
    },
    target: {
      required: false,
      default: '',
    },
    isShowCountDown: {
      required: false,
      default: false,
    },
    day: {
      required: false,
      default: '',
    },
    month: {
      required: false,
      default: '',
    },
    isShowTime: {
      required: false,
      default: false,
    },
    isShowLikePart: {
      required: false,
      default: false,
    },
    likeNum: {
      required: false,
      default: 0,
    },
    author: {
      required: false,
      default: '',
    },
    isShowAuthor: {
      required: false,
      default: false,
    },
    likeNumBottomLimit: {
      required: false,
      default: 100,
    }
  },
  setup(props: any) {
    const { state } = useStore();
    const leftBg = computed(() => {
      if (state.gameId == 263) {
        return `background-image:linear-gradient(to right, rgba(22, 34, 32, 0), rgba(0, 0, 0, .4) 80%),url(${props.leftBg});`;
      }
      return setBg(props.leftBg);
    });
    const itemBg = computed(() => {
      if (props.itemBg) {
        return setBg(props.itemBg);
      }
      return '';
    });
    const LeftTime = computed(() => {
      return formatSecond(props.countdownSecond);
    });
    const { articleJumpLink } = useArticleJumpLink();
    const checkLikeNumReach = computed(() => {
      return +props.likeNum >= +props.likeNumBottomLimit
    })

    return {
      leftBg,
      itemBg,
      LeftTime,
      articleJumpLink,
      checkLikeNumReach
    };
  },
  components: {
    ArticleCountDown,
  },
});
